var _defs, _g, _g2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBottomCart(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 68.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#55bd22;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "533.02 40.35 553.97 40.35 556.73 27.38 530.26 27.38 533.02 40.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M582.38,41.97c-.23-23.22-19.11-41.97-42.38-41.97s-42.15,18.75-42.38,41.97H0v26.31H1080v-26.31h-497.62Zm-48.47,17.16c-2.27,0-4.12-1.85-4.12-4.12s1.85-4.12,4.12-4.12,4.12,1.85,4.12,4.12-1.85,4.12-4.12,4.12Zm17.63,0c-2.27,0-4.12-1.85-4.12-4.12s1.85-4.12,4.12-4.12,4.12,1.85,4.12,4.12-1.85,4.12-4.12,4.12Zm9.57-33.31l-3.6,16.92c-.19,.91-1,1.57-1.93,1.57h-22.81c-.5,0-.91,.41-.91,.91s.41,.91,.91,.91h22.81c1.09,0,1.98,.89,1.98,1.98s-.88,1.98-1.98,1.98h-22.81c-2.68,0-4.86-2.18-4.86-4.86,0-1.32,.53-2.52,1.39-3.39l-4.29-20.2h-4.16c-1.09,0-1.98-.89-1.98-1.98s.88-1.98,1.98-1.98h5.77c.93,0,1.74,.65,1.93,1.57l.89,4.2h29.74c.6,0,1.16,.27,1.54,.73s.52,1.07,.4,1.66Z"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomCart);
export default __webpack_public_path__ + "static/media/bottom-cart.f97056618684db24986da05fbe7d85fc.svg";
export { ForwardRef as ReactComponent };